import { joinStr } from '@utils'
import AgentCard from './agent'
import { isShowFavoriteButton, isShowTrackButton } from '@utils/house'
import TrackButton from '@component/card/listings/track'
import { FavouriteHeart } from '@component/card/listings/favourite'
import ShareProperty from '../share'
import useProgressRouter from '@hooks/useProgressRouter'

export default function ListingBar({
  data,
  barClick
}) {

  const { backRouter } = useProgressRouter()

  return (
    <div className='flex items-center justify-between py-10'>
      <button className='button-text-primary text-base flex items-center' aria-label='go to back' onClick={barClick || backRouter}>
        <i className='icon icon-back mr-4 !text-xl'></i>
        <span className='md:hidden'>back to search result</span>
        <span className='hidden md:inline-block'>back</span>
      </button>
      <address className='not-italic line-clamp-2 text-lg hidden lg:block'>{joinStr([data.street, data.suburb], ', ')}</address>
      <AgentCard data={data} className='!hidden sm:!flex' barClick={barClick}></AgentCard>
      {
        // 是否显示favorite button
        isShowFavoriteButton(data) && (
          <div className='flex items-center gap-x-16'>
            <FavouriteHeart data={data} signupSource='Save_Property' onClick={barClick}></FavouriteHeart>
            <ShareProperty data={data}></ShareProperty>
          </div>
        )
      }
      {
        // 是否显示track button
        isShowTrackButton(data) && (
          <TrackButton data={data} signupSource='Track_Home' className='rounded-4xl' onClick={barClick}></TrackButton>
        )
      }
    </div>
  )
}